import { Button } from '@mui/material';
import React, { Component } from 'react';
import './style.css';

class CourseDetails extends Component {
  continue = e => {
    e.preventDefault();
    if (this.props.licenceExpiry === null) {
      this.props.setDefaultValues('licenceExpiry');
    }
    this.props.nextStep();
  };
  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      handleChange,
      driverlicenceno,
      driverlicencetype,
      driverlicenceversion,
      occupation,
      employer,
      licenceExpiry,
    } = this.props;

    return (
      <div className="form">
        <form>
          <div className="form-group">
            <div className="form-group__element">
              <label htmlFor="first name" className="form-group__label">
                Driving Licence Number (Please leave blank if you dont have a NZ Licence)
              </label>
              <input
                type="text"
                value={driverlicenceno}
                name="driverlicenceno"
                onChange={handleChange('driverlicenceno')}
                className="form-group__input"
              />
            </div>
            <div className="form-group__element">
              <label htmlFor="middle name" className="form-group__label">
                Driving Licence Version (Please leave blank if you dont have a NZ Licence)
              </label>
              <input
                type="text"
                value={driverlicenceversion}
                name="driverlicenceversion"
                onChange={handleChange('driverlicenceversion')}
                className="form-group__input"
              />
            </div>

            <div className="form-group__element">
              <label htmlFor="last name" className="form-group__label">
                Driver Licence Type (Please leave blank if you dont have a NZ Licence)
              </label>
              <select
                className="form-group__select"
                value={driverlicencetype}
                onChange={handleChange('driverlicencetype')}
              >
                <option value="Full">Full</option>
                <option value="Restricted">Restricted</option>
                <option value="Learners">Learners</option>
                <option value="Overseas">Overseas</option>
              </select>
            </div>

            <div className="form-group__element">
              <label htmlFor="email" className="form-group__label">
                Employer
              </label>
              <input
                type="text"
                value={employer}
                name="employer"
                onChange={handleChange('employer')}
                className="form-group__input"
              />
            </div>

            <div className="form-group__element">
              <label htmlFor="phone" className="form-group__label">
                Occupation
              </label>
              <input
                type="text"
                value={occupation}
                name="occupation"
                onChange={handleChange('occupation')}
                className="form-group__input"
              />
            </div>

            <div className="form-group__element">
              <label htmlFor="licenceExpiry" className="form-group__label">
                Licence Expiry
              </label>
              <input
                type="date"
                value={licenceExpiry}
                name="licenceExpiry"
                onChange={handleChange('licenceExpiry')}
                className="form-group__input"
              />
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Button variant="contained" sx={{ backgroundColor: '#b4855a' }} onClick={this.back}>
              Back
            </Button>{' '}
            &nbsp;
            <Button variant="contained" sx={{ backgroundColor: '#b4855a' }} onClick={this.continue}>
              Next
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CourseDetails;
